import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '@/firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeUser: '',
    userSettingsLoading: true,
    activeUserSettings: {
      isAdmin: false
    },
    lookupModal: {
      show: false,
      englishWord: '',
      spanishWord: ''
    },
    lookupModalV2: {},
    booklist: {},
    selectedBook: {},
    bookreader: {
      currentpage: 0,
      pages: [],
      pagesDic: null,
      booklength: 0,
      readingId: ''
    }
  },
  getters: {
    getCurrentPageStore(state) {
      return state.bookreader.currentpage
    },
    getBookPagesDicStore(state) {
      if (state.bookreader.pagesDic) {
        return state.bookreader.pagesDic
      } else {
        return false
      }
    },
    getHasPagesDicInStore(state) {
      if (state.bookreader.pagesDic) {
        return true
      } else {
        return false
      }
    },
    getBooklengthStore(state) {
      return state.bookreader.booklength
    },
    getBookPagesStore(state) {
      return state.bookreader.pages
    },
    getReaditId(state) {
      return state.bookreader.readingId
    },
    lookupModal(state) {
      return state.lookupModal
    },
    showLookupModal(state) {
      return state.lookupModal.show
    },
    getLookupWords(state) {
      return {
        englishWord: state.lookupModal.englishWord,
        spanishWord: state.lookupModal.spanishWord
      }
    },
    getLookupWordsV2(state) {
      return state.lookupModalV2
    },
    getBooklist(state) {
      return state.booklist
    },
    getSelectedBook(state) {
      return state.selectedBook
    },
    getActiveUser(state) {
      return state.activeUser
    },
    getActiveUserSettings(state) {
      return state.activeUserSettings
    },
    getUserSettingsLoading(state) {
      return state.userSettingsLoading
    }
  },
  mutations: {
    openLookupModal(state) {
      state.lookupModal.show = true
    },
    closeLookupModal(state) {
      state.lookupModal.show = false
    },
    setLookupWords(state, words) {
      state.lookupModal.englishWord = words.eng
      state.lookupModal.spanishWord = words.esp
    },
    setLookupWordsV2(state, wordObj) {
      state.lookupModalV2 = wordObj

    },
    setBooklist(state, data) {
      state.booklist = data
    },
    setSelectedBook(state, bookData) {
      state.selectedBook = bookData
    },
    setBookreaderPages(state, pages) {
      state.bookreader.pages = pages
    },
    setBookreaderPagesDic(state, pagesDic){
      state.bookreader.pagesDic = pagesDic
    },
    setBookreaderBookLength(state, length) {
      state.bookreader.booklength = length
    },
    setCurrentpage(state, pageindex) {
      state.bookreader.currentpage = pageindex
    },
    setCurrentpageReadingId(state, readingId) {
      state.bookreader.readingId =  readingId
    },
    setActiveUser(state, userid) {
      state.activeUser = userid
    },
    setActiveUserSettings(state, settings) {
      state.activeUserSettings = {
        isAdmin: settings.isAdmin
      },
      state.userSettingsLoading = false
    },
  },
  actions: {
    setActiverUserSettingsAction(context, userid) {
      db.collection(`users`)
      .doc(userid)
      .get().then((snap) => {
        context.commit('setActiveUserSettings',
        {
          isAdmin: snap.data().isAdmin
        })
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    setBookreaderPagesAction(context, bookid) {
      db.collection(`books/`)
      .where('isbn', '==', `${bookid}`)
      .get().then((snap) => {
        snap.docs.forEach(doc => {
          if(doc.data().pagesDic) {
            // console.log('It has a pagesDic')
            context.commit('setBookreaderPagesDic', doc.data().pagesDic)
          } else {
            // console.log('It doesnt has a pageDic')
            context.commit('setBookreaderPagesDic', null)
          }
          context.commit('setBookreaderPages', doc.data().pages)
          context.commit('setBookreaderBookLength', doc.data().pages.length)
        })
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    setBookreaderCurrentPage(context, payload) {
      db.collection(`users`).doc(payload.user).collection('reading')
      .where('isbn', '==', `${payload.bookid}`)
      .get().then((snap) => {
        if(snap.docs.length) {
          context.commit('setCurrentpageReadingId', snap.docs[0].id)
          context.commit('setCurrentpage', snap.docs[0].data().pageIndex)
        } else {
          context.commit('setCurrentpageReadingId', '')
          context.commit('setCurrentpage', 0)
        }
      })
      .catch(function(error) {
        console.log( error);
      });
    }
  },
  modules: {
  }
})
